import alerts from './tasks/alerts';
import buttons from './tasks/buttons';

export default {
    alerts,
    buttons,

    head: {
        taskView: 'Просмотр задачи',
    },

    alert: {
        secondary: 'Task in processing',
        danger: 'Error',
    },

    fields: {
        orderId: 'Order number',
        taskType: 'Task type',
        taskDate: 'Date of creation',
        dateComplete: 'Date of execution',
        taskStatus: 'Status',
        pfm: 'PFM Store Code',
        deliveryServiceId: 'Type of delivery',
        taskImportance: 'Priority',
        taskId: 'Issue number',
        updatedFrom: 'System',
    },

    packagesPerOrder: {
        title: 'Packages in order',
        packageType: 'Package type',
        numberOfPcs: 'Quantity pcs.',
        setPackagesCount: 'Please specify the number of packages',
        packageCountNotification: 'You need to add at least 1 package to the order, but no more than {quantity} pieces',
        packInSpecifiedQuantity: 'You need to assemble the order in the specified number of packages!',
        needMorePackages: 'There is already 1 package in the order, do you want to add more?',
    },

    filter: {
        orderId: 'Order number',
        taskDateFrom: 'Date of creation: from',
        taskDateTo: 'Date of creation: before',
        pfm: 'PFM Store Code',
        taskTypes: 'Task type',
        statuses: 'Status',
        selectedTaskTypes: 'Selected types',
        selectedStatuses: 'Selected statuses',

        types: {
            action: 'Actual',
            all: 'All',
        },

        buttonClear: 'Clear',
    },

    list: {
        deliveryService: 'Pickup',
        textFormsPre: 'Found | Found | Found',
        textFormsPast: 'task | tasks | tasks',
    },

    view: 'Task for {title} № {orderId}',

    mixins: {
        types: {
            formatting: 'order formation',
            confirming: 'order approval',
            disbanding: 'disbandment of the order',
            paying: 'a note about the payment of the order',
            delivery: 'delivery of the order',
            printTransferDoc: 'printing of transfer documents',
            formationDelivery: 'formation in the delivery of the order',
            confirmingDelivery: 'coordination of the order with delivery',
            editAfterFormatting: 'editing after order formation',
            returnFromShipping: 'return from courier service',
        },

        typeTitle: 'actions with the order',
    },
};